import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { TRACKING_TYPES } from './constants'
import useGetMultiplyCityAdvancedTrackingPopup from './MultiplyAdvance/useGetMultiplyCityAdvancedTrackingPopup'
import useGetMultiplyCityBasicTrackingPopup from './MultiplyBasic/useGetMultiplyCityBasicTrackingPopup'
import useGetCodesTypePopupInfo from './SelectTrackingType/useGetCodesTypePopupInfo'
import useGetSingleCityAdvancedTrackingPopup from './SingleAdvance/useGetSingleCityAdvancedTrackingPopup'
import useGetSingleCityBasicTrackingPopup from './SingleBasic/useGetSingleCityBasicTrackingPopup'
const useGetActivePopupInfo = ({
  trackingType,
  setTrackingType,
  codesTable,
  fileError,
  onConfirm,
  onCloseHandler,
  setCriticalError,
  setFile,
  setWarning,
  error,
  warning,
  setCodesTable,
  isCodesUploading,
  setShowCodesExplanationPage,
}) => {
  const params = useParams()
  const campaign = useSelector(
    state => state.campaigns.campaigns[params.campaignId],
  )
  const citiesArray = campaign.cityPlans.nodes.map(node => ({
    name: node.city.name,
    id: node.city.id,
  }))

  const cityCount = citiesArray.length

  const payload = {
    onConfirm,
    onClose: onCloseHandler,
    isCanBeConfirmed: !fileError && !!codesTable,
    setCriticalError,
    setFile,
    error,
    warning,
    setCodesTable,
    setWarning,
    citiesArray,
    isCodesUploading,
  }

  const {
    title: codesTypePopupTitle,
    body: CodesTypePopupBody,
    footer: CodesTypePopupFooter,
  } = useGetCodesTypePopupInfo(setTrackingType, setShowCodesExplanationPage)

  const {
    title: multiplyAdvancedTitle,
    body: multiplyAdvancedBody,
    footer: multiplyAdvancedFooter,
  } = useGetMultiplyCityAdvancedTrackingPopup(payload)

  const {
    title: multiplyBasicTitle,
    body: multiplyBasicBody,
    footer: multiplyBasicFooter,
  } = useGetMultiplyCityBasicTrackingPopup(payload)

  const {
    title: singleAdvancedTitle,
    body: singleAdvancedBody,
    footer: singleAdvancedFooter,
  } = useGetSingleCityAdvancedTrackingPopup(payload)

  const {
    title: singleBasicTitle,
    body: singleBasicBody,
    footer: singleBasicFooter,
  } = useGetSingleCityBasicTrackingPopup(payload)

  if (trackingType === TRACKING_TYPES.BASIC && cityCount > 1) {
    return {
      title: multiplyBasicTitle,
      body: multiplyBasicBody,
      footer: multiplyBasicFooter,
    }
  }
  if (trackingType === TRACKING_TYPES.BASIC && cityCount === 1) {
    return {
      title: singleBasicTitle,
      body: singleBasicBody,
      footer: singleBasicFooter,
    }
  }
  if (trackingType === TRACKING_TYPES.ADVANCED && cityCount > 1) {
    return {
      title: multiplyAdvancedTitle,
      body: multiplyAdvancedBody,
      footer: multiplyAdvancedFooter,
    }
  }
  if (trackingType === TRACKING_TYPES.ADVANCED && cityCount === 1) {
    return {
      title: singleAdvancedTitle,
      body: singleAdvancedBody,
      footer: singleAdvancedFooter,
    }
  }

  return {
    title: codesTypePopupTitle,
    body: CodesTypePopupBody,
    footer: CodesTypePopupFooter,
  }
}

export default useGetActivePopupInfo
